var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-container"},[_c('div',{staticClass:"contact-content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('留下联系方式，获取更多信息')))]),_c('el-button',{on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t('咨询合作')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }